import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/FilePdfColor.tsx
const FilePdfColorIcon = ZepIcon((props) => /* @__PURE__ */ jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ jsx("path", {
			d: "m15.932 2 5.566 5.687v12.25c0 1.692-1.334 3.063-2.98 3.063H7.03c-1.645 0-2.978-1.371-2.978-3.062V5.062C4.05 3.371 5.384 2 7.029 2h8.903Z",
			fill: "url(#paint0_linear_869_1204)"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "m18.733 4.844 2.766 2.843v4.375L16.392 7.25l2.34-2.406Z",
			fill: "url(#paint1_linear_869_1204)",
			fillOpacity: .3
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M21.499 7.688h-4.347c-.655 0-1.22-.588-1.22-1.313V2l5.567 5.688Z",
			fill: "#EC7730"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M1.5 12.587c0-1.208.953-2.188 2.128-2.188H14.69c1.176 0 2.128.98 2.128 2.188v5.687c0 1.209-.952 2.188-2.127 2.188H3.627c-1.175 0-2.128-.98-2.128-2.188v-5.687Z",
			fill: "url(#paint2_linear_869_1204)"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M14.691 10.4c1.176 0 2.128.979 2.128 2.187 0-1.087-.952-1.969-2.127-1.969H3.627c-1.175 0-2.128.882-2.128 1.969 0-1.208.953-2.188 2.128-2.188H14.69Z",
			fill: "#fff",
			fillOpacity: .7
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M11.885 17.969v-4.95h3.172v.848h-2.174v1.203h1.968v.848h-1.968v2.05h-.998ZM9.08 17.969H7.383v-4.95h1.715c1.45 0 2.337.927 2.334 2.468.003 1.549-.884 2.482-2.354 2.482Zm-.699-.882h.658c.918 0 1.397-.489 1.397-1.6 0-1.1-.48-1.586-1.39-1.586h-.665v3.186ZM3.414 17.969v-4.95h1.888c1.094 0 1.722.694 1.722 1.668 0 .988-.638 1.668-1.748 1.668H4.41v1.614h-.997Zm.997-2.44h.705c.592 0 .881-.342.878-.841.003-.493-.286-.824-.878-.828h-.705v1.668Z",
			fill: "#EFF9FF"
		}),
		/* @__PURE__ */ jsxs("defs", { children: [
			/* @__PURE__ */ jsxs("linearGradient", {
				id: "paint0_linear_869_1204",
				x1: 12.774,
				y1: 2,
				x2: 12.774,
				y2: 23,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ jsx("stop", { stopColor: "#FFC798" }), /* @__PURE__ */ jsx("stop", {
					offset: 1,
					stopColor: "#FF945F"
				})]
			}),
			/* @__PURE__ */ jsxs("linearGradient", {
				id: "paint1_linear_869_1204",
				x1: 18.945,
				y1: 4.844,
				x2: 18.945,
				y2: 12.063,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ jsx("stop", { stopColor: "#CE420B" }), /* @__PURE__ */ jsx("stop", {
					offset: 1,
					stopColor: "#FEBD92"
				})]
			}),
			/* @__PURE__ */ jsxs("linearGradient", {
				id: "paint2_linear_869_1204",
				x1: 9.16,
				y1: 10.399,
				x2: 9.16,
				y2: 20.462,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ jsx("stop", { stopColor: "#ED684D" }), /* @__PURE__ */ jsx("stop", {
					offset: 1,
					stopColor: "#D35735"
				})]
			})
		] })
	]
}));
//#endregion
export { FilePdfColorIcon };
